import { render, staticRenderFns } from "./navbar_bottom.vue?vue&type=template&id=4b2d2d1d&"
import script from "./navbar_bottom.vue?vue&type=script&lang=js&"
export * from "./navbar_bottom.vue?vue&type=script&lang=js&"
import style0 from "./navbar_bottom.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports